import UnicornApp from '../app';
import { defData } from '../utilities';
import UnicornHelper from './helper';
import UnicornLang from './lang';
/**
 * UnicornGrid
 */
export default class UnicornGrid {
    app;
    static get is() { return 'grid'; }
    static install(app, options = {}) {
        const grid = new this(app);
        app.grid = grid.get.bind(grid);
    }
    constructor(app) {
        this.app = app;
    }
    get(ele, options = {}) {
        const selector = typeof ele === 'string' ? ele : '';
        const element = this.app.inject('$helper').selectOne(ele);
        if (!element) {
            throw new Error('Element is empty');
        }
        return defData(element, 'grid.plugin', () => new UnicornGridElement(this.app, selector, element, options));
    }
    ;
}
const defaultOptions = {};
export class UnicornGridElement {
    app;
    element;
    options;
    form;
    ordering = '';
    state = {};
    static get defaultOptions() {
        return {
        //
        };
    }
    constructor(app, selector, element, options = {}) {
        this.app = app;
        this.element = element;
        this.options = Object.assign({}, defaultOptions, options);
        this.form = app.form(selector || element);
        if (!this.form) {
            throw new Error('UnicornGrid is dependent on UnicornForm');
        }
        this.bindEvents();
    }
    get $helper() {
        return this.app.inject('$helper');
    }
    get $lang() {
        return this.app.inject('$lang');
    }
    bindEvents() {
        this.$helper.selectAll('input[data-role=grid-checkbox]', (ch) => {
            ch.addEventListener('click', () => {
                ch.dispatchEvent(new CustomEvent('change'));
            });
            ch.addEventListener('change', () => {
                const event = new CustomEvent('unicorn:checked', {
                    detail: { grid: this }
                });
                this.form.element?.dispatchEvent(event);
            });
        });
    }
    initComponent(store = 'grid', custom = {}) {
        this.ordering = this.element?.dataset?.ordering || '';
        if (this.ordering) {
            if (!this.ordering.toLowerCase().endsWith(' asc')
                && !this.ordering.toLowerCase().endsWith(' desc')) {
                this.ordering += ' ASC';
            }
        }
        return this.app.loadAlpine(() => {
            Alpine.store(store, this.useState(custom));
        });
    }
    useState(custom = {}) {
        const state = {
            form: this.form.useState(custom),
        };
        Object.getOwnPropertyNames(Object.getPrototypeOf(this))
            .map(item => {
            const prop = this[item];
            if (typeof prop === 'function') {
                return state[item] = this[item].bind(this);
            }
            return item;
        });
        return Object.assign(state, custom);
    }
    getElement() {
        return this.element;
    }
    sendFilter($event = undefined, method = null) {
        if ($event) {
            $event.preventDefault();
        }
        this.form.submit(null, null, method);
    }
    clearFilters(element, method) {
        element.querySelectorAll('input, textarea, select').forEach((ele) => {
            ele.value = '';
        });
        this.form.submit(null, null, method);
    }
    toggleFilters(open, filterForm) {
        if (open) {
            this.app.$ui.slideDown(filterForm);
        }
        else {
            this.app.$ui.slideUp(filterForm);
        }
    }
    sort($el) {
        const dir = this.getDirection($el);
        const field = $el.dataset.field;
        let asc = $el.dataset.asc;
        let desc = $el.dataset.desc;
        if (field) {
            asc = field + ' ASC';
            desc = field + ' DESC';
        }
        if (dir === 'ASC') {
            return this.sortBy(desc);
        }
        return this.sortBy(asc);
    }
    /**
     * Sort two items.
     */
    sortBy(ordering) {
        if (!ordering) {
            return false;
        }
        let orderingInput = this.element.querySelector('input[name=list_ordering]');
        if (!orderingInput) {
            orderingInput = this.$helper.h('input', { name: 'list_ordering', type: 'hidden', value: '' });
            this.element.appendChild(orderingInput);
        }
        orderingInput.value = ordering;
        return this.form.put();
    }
    isSortActive($el) {
        return this.getDirection($el) != null;
    }
    getDirection($el) {
        const field = $el.dataset.field;
        let asc = $el.dataset.asc;
        let desc = $el.dataset.desc;
        if (field) {
            asc = field + ' ASC';
            desc = field + ' DESC';
        }
        if (this.orderingEquals(asc, this.ordering)) {
            return 'ASC';
        }
        else if (this.orderingEquals(desc, this.ordering)) {
            return 'DESC';
        }
        return null;
    }
    orderingEquals(a, b) {
        a = a || '';
        b = b || '';
        a = a.replace(/\s+/g, ' ').trim().toLowerCase();
        b = b.replace(/\s+/g, ' ').trim().toLowerCase();
        return a === b;
    }
    /**
     * Check a row's checkbox.
     */
    checkRow(row, value = true) {
        const ch = this.getCheckboxByRow(row);
        if (!ch) {
            throw new Error('Checkbox of row: ' + row + ' not found.');
        }
        ch.checked = value;
        ch.dispatchEvent(new Event('input'));
        ch.dispatchEvent(new Event('change'));
    }
    getCheckboxByRow(row) {
        return this.form.element?.querySelector(`input[data-role=grid-checkbox][data-row-number="${row}"]`);
    }
    /**
     * Update a row.
     */
    updateRow(row, url, data) {
        const ch = this.getCheckboxByRow(row);
        if (!ch) {
            return false;
        }
        return this.updateItem(ch.value, url, data);
    }
    /**
     * Update an item by id.
     */
    updateItem(id, url, data) {
        this.toggleAll(false);
        this.disableAllCheckboxes();
        this.form.injectInput('id[]', id);
        return this.form.patch(url, data);
    }
    /**
     * Update a item with batch task.
     */
    updateItemByTask(task, id, url, data) {
        data = data || {};
        data.task = task;
        return this.updateItem(id, url, data);
    }
    /**
     * Update a row with batch task.
     */
    updateRowByTask(task, row, url, data) {
        const ch = this.getCheckboxByRow(row);
        if (!ch) {
            return false;
        }
        return this.updateItemByTask(task, ch.value, url, data);
    }
    /**
     * @deprecated  Use updateItemByTask() instead.
     */
    doTask(task, id, url, data) {
        return this.updateItemByTask(task, id, url, data);
    }
    /**
     * Batch update items.
     */
    updateByTask(task, url, data) {
        data = data || {};
        data.task = task;
        return this.form.patch(url, data);
    }
    batch(task, url, data) {
        return this.updateByTask(task, url, data);
    }
    /**
     * Copy a row.
     */
    copyItem(id, url, data) {
        this.toggleAll(false);
        this.disableAllCheckboxes();
        this.form.injectInput('id[]', id);
        return this.form.post(url, data);
    }
    /**
     * Copy a row.
     */
    copyRow(row, url, data) {
        const ch = this.getCheckboxByRow(row);
        if (!ch) {
            return false;
        }
        return this.copyItem(ch.value, url, data);
    }
    /**
     * Delete checked items.
     */
    deleteList(message, url, data) {
        if (!this.validateChecked()) {
            return false;
        }
        message = message == null ? this.$lang.__('unicorn.message.delete.confirm') : message;
        if (message !== false) {
            this.$helper.confirm(message).then(isConfirm => {
                if (isConfirm) {
                    this.form.delete(url, data);
                }
            });
        }
        else {
            this.form.delete(url, data);
        }
        return true;
    }
    /**
     * Delete an item by row.
     */
    async deleteRow(row, msg, url, data) {
        const ch = this.getCheckboxByRow(row);
        if (!ch) {
            return false;
        }
        return this.deleteItem(ch.value, msg, url, data);
    }
    /**
     * Delete an item.
     */
    async deleteItem(id, msg, url, data) {
        msg = msg || this.$lang.__('unicorn.message.delete.confirm');
        return this.$helper.confirm(msg)
            .then((isConfirm) => {
            if (isConfirm) {
                // this.toggleAll(false);
                // this.checkRow(row);
                data = data || {};
                data.id = id;
                this.form.delete(url, data);
            }
            return isConfirm;
        });
    }
    /**
     * Toggle all checkboxes.
     */
    toggleAll(value) {
        this.$helper.selectAll(this.element.querySelectorAll('input[data-role=grid-checkbox][type=checkbox]'))
            .map((input) => {
            input.checked = value;
            input.dispatchEvent(new CustomEvent('input'));
            input.dispatchEvent(new CustomEvent('change'));
        });
        return this;
    }
    disableAllCheckboxes() {
        this.$helper.selectAll(this.element.querySelectorAll('input[data-role=grid-checkbox][type=checkbox]'), (input) => {
            input.disabled = true;
        });
    }
    /**
     * Count checked checkboxes.
     */
    countChecked() {
        return this.getChecked().length;
    }
    /**
     * Get Checked boxes.
     */
    getChecked() {
        return this.$helper.selectAll(this.element.querySelectorAll('input[data-role=grid-checkbox][type=checkbox]:checked'));
    }
    getCheckedValues() {
        return this.getChecked().map(input => input.value);
    }
    /**
     * Validate there has one or more checked boxes.
     */
    validateChecked(event, callback, msg) {
        msg = msg || this.$lang.__('unicorn.message.grid.checked');
        if (!this.hasChecked()) {
            if (msg !== '') {
                this.app.alert(msg);
            }
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            return this;
        }
        if (callback) {
            callback(this);
        }
        return this;
    }
    hasChecked() {
        return this.countChecked() > 0;
    }
    /**
     * Reorder all.
     */
    reorderAll(url, data) {
        return this.batch('reorder', url, data);
    }
    /**
     * Reorder items.
     */
    moveItem(id, delta, url, data) {
        data = data || {};
        data.delta = delta;
        return this.updateItemByTask('move', id, url, data);
    }
    moveUp(id, url, data) {
        return this.moveItem(id, -1, url, data);
    }
    moveDown(id, url, data) {
        return this.moveItem(id, 1, url, data);
    }
    getId(suffix = '') {
        return this.form.element?.id + suffix;
    }
}
